import zhCN from 'antd/locale/zh_CN';
import type { CustomLocale } from '../types/antd';

const custom: CustomLocale = {
  CopyButton: {
    label: '复制',
    successText: '复制成功。',
    failedText: '复制失败。',
  },
  ToggleButton: {
    activeText: '激活',
    inactiveText: '停用',
  },
};

export default {
  ...zhCN,
  custom,
};
